module.exports = __webpack_public_path__ + "static/media/arrow_down.b5a8c240.svg";